"use strict";

import React from "react";
import _ from "lodash";

import WP from "../../constants/WP";

function WordpressFieldLabel(props) {
  let { element } = props;

  let wpField = element.getIn(["wp", "field"]);

  let label = _.get(_.find(WP.PLACEHOLDERS, { key: wpField }), "label", "WordPress");

  let style = {
    height: 25,
    padding: 5,
    lineHeight: "15px",
    whiteSpace: "nowrap",
  };

  return <div style={style}>{label}</div>;
}

export default WordpressFieldLabel;
